export const DISABLE_NOTIFICATION_FLAG = true;
export const DISABLED_CHAT_NEW_FLAG = true;

export const TEXTKIT_NOTIFICATION_SOUND = "TEXTKIT_NOTIFICATION_SOUND";